import React from 'react';
import PropTypes from 'prop-types';

import basketModes from 'apps/basket/utils/basketModes';

const BasketSummaryEdit = ({ basketMode, displayWarning, isLoggedIn }) => (
  (
    isLoggedIn &&
    (basketMode === basketModes.EDIT || basketMode === basketModes.REORDER)
  )
    ? (
      <div className="hd-basketSummary__edit">
        <span className="hd-basketSummary__editMessage">
          {basketMode === basketModes.EDIT ? 'Editing an order' : 'Reordering'}
        </span>
        <button
          onClick={displayWarning}
          className="hd-basketSummary__cancelButton button-link"
        >
          Cancel changes
        </button>
      </div>
    )
    : null
);

BasketSummaryEdit.propTypes = {
  basketMode: PropTypes.oneOf(Object.values(basketModes)).isRequired,
  displayWarning: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default BasketSummaryEdit;
